import { render, staticRenderFns } from "./CopyrightAmendmentFormsDetails.vue?vue&type=template&id=713ea1f4&scoped=true&"
import script from "./CopyrightAmendmentFormsDetails.vue?vue&type=script&lang=js&"
export * from "./CopyrightAmendmentFormsDetails.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightAmendmentFormsDetails.vue?vue&type=style&index=0&id=713ea1f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713ea1f4",
  null
  
)

export default component.exports